import { endpoint } from '@library/endpoint'

import routes from 'config/routes'
// TODO: remove when fetch.js converted to ts
// eslint-disable-next-line import/extensions
import { fetch, fetchRaw } from 'utils/fetch.js'

export function applyPromo(accessToken: string, promoCode: string) {
  return fetch(
    accessToken,
    `${endpoint('core')}/user/current/applyPromotionCode/${promoCode}`,
    {},
    'POST',
  )
}

export function fetchUserCredit(accessToken: string) {
  return fetch(accessToken, `${endpoint('core')}/user/current/balance`, {}, 'GET')
}

export function fetchReferralOffer(accessToken: string) {
  return fetch(accessToken, `${endpoint('core')}/user/current/raf-campaign-details`, {}, 'GET')
}

export function fetchPromo(accessToken: string) {
  return fetch(accessToken, `${endpoint('core')}${routes.core.userPromo}`, {}, 'GET')
}

export function fetchUser(accessToken: string) {
  return fetch(accessToken, `${endpoint('core')}${routes.core.currentUser}`, {}, 'GET')
}

export function fetchShippingAddresses(accessToken: string) {
  return fetch(
    accessToken,
    `${endpoint('core')}${routes.core.userAddress}`,
    { type: 'shipping' },
    'GET',
  )
}

export function fetchUserOrders(accessToken: string, reqData?: Record<string, unknown>) {
  return fetch(accessToken, `${endpoint('core')}${routes.core.userOrders}`, reqData, 'GET')
}

export function reactivate(accessToken: string, reqData: { userId: string }) {
  return fetch(accessToken, `${endpoint('core')}/user/${reqData.userId}/restore`, {}, 'PUT')
}

export function verifyAge(accessToken: string, userId: string) {
  return fetch(accessToken, `${endpoint('core')}/user/${userId}`, { age_verified: 1 }, 'PUT')
}

export function checkDuplicateUser(reqData?: Record<string, unknown>) {
  return fetch(null, `${endpoint('core')}/user/check-duplicate`, reqData, 'POST')
}

export function referralDetails(accessToken: string, reqData?: Record<string, unknown>) {
  return fetch(accessToken, `${endpoint('core')}/user/current/referralDetails`, reqData, 'GET')
}

export function addPaymentMethod(
  accessToken: string,
  reqData: Record<string, unknown>,
  userId: string,
) {
  return fetch(accessToken, `${endpoint('core')}/user/${userId}/paymentMethod`, reqData, 'PUT')
}

export function fetchUserAddresses(accessToken: string) {
  return fetch(accessToken, `${endpoint('core')}${routes.core.userAddress}`, {}, 'GET')
}
export function deleteMarketingSubscription(
  authUserId: string,
  marketingType: string,
  marketingUnsubscribeToken: string,
) {
  return fetchRaw(
    `${endpoint('core')}/user/${authUserId}/marketing/${marketingType}`,
    { marketing_unsubscribe_token: marketingUnsubscribeToken },
    { method: 'PUT', useOverwriteRequestMethod: false },
  )
}
